module.exports = __webpack_public_path__ + "img/bg_x_black_for_component.b5a0e988.jpg";